import {LocaleInterface} from '../interfaces/locale.interface';

export const LOCALES: LocaleInterface[] = [
  { "code": "aa", "language": "Afar" },
  { "code": "aa-ER", "language": "Afar (Eritrea)" },
  { "code": "af", "language": "Afrikaans" },
  { "code": "af-NA", "language": "Afrikaans (Namibia)" },
  { "code": "af-ZA", "language": "Afrikaans (South Africa)" },
  { "code": "ak", "language": "Akan" },
  { "code": "ak-GH", "language": "Akan (Ghana)" },
  { "code": "am", "language": "Amharic" },
  { "code": "am-ET", "language": "Amharic (Ethiopia)" },
  { "code": "ar", "language": "Arabic" },
  { "code": "ar-AE", "language": "Arabic (United Arab Emirates)" },
  { "code": "ar-BH", "language": "Arabic (Bahrain)" },
  { "code": "ar-DJ", "language": "Arabic (Djibouti)" },
  { "code": "ar-DZ", "language": "Arabic (Algeria)" },
  { "code": "ar-EG", "language": "Arabic (Egypt)" },
  { "code": "ar-ER", "language": "Arabic (Eritrea)" },
  { "code": "ar-IL", "language": "Arabic (Israel)" },
  { "code": "ar-IQ", "language": "Arabic (Iraq)" },
  { "code": "ar-JO", "language": "Arabic (Jordan)" },
  { "code": "ar-KM", "language": "Arabic (Comoros)" },
  { "code": "ar-KW", "language": "Arabic (Kuwait)" },
  { "code": "ar-LB", "language": "Arabic (Lebanon)" },
  { "code": "ar-LY", "language": "Arabic (Libya)" },
  { "code": "ar-MA", "language": "Arabic (Morocco)" },
  { "code": "ar-MR", "language": "Arabic (Mauritania)" },
  { "code": "ar-OM", "language": "Arabic (Oman)" },
  { "code": "ar-PS", "language": "Arabic (Palestine)" },
  { "code": "ar-QA", "language": "Arabic (Qatar)" },
  { "code": "ar-SA", "language": "Arabic (Saudi Arabia)" },
  { "code": "ar-SD", "language": "Arabic (Sudan)" },
  { "code": "ar-SO", "language": "Arabic (Somalia)" },
  { "code": "ar-SY", "language": "Arabic (Syria)" },
  { "code": "ar-TD", "language": "Arabic (Chad)" },
  { "code": "ar-TN", "language": "Arabic (Tunisia)" },
  { "code": "ar-YE", "language": "Arabic (Yemen)" },
  { "code": "as", "language": "Assamese" },
  { "code": "as-IN", "language": "Assamese (India)" },
  { "code": "ay", "language": "Aymara" },
  { "code": "ay-BO", "language": "Aymara (Bolivia)" },
  { "code": "az", "language": "Azerbaijani" },
  { "code": "az-AZ", "language": "Azerbaijani (Azerbaijan)" },
  { "code": "be", "language": "Belarusian" },
  { "code": "be-BY", "language": "Belarusian (Belarus)" },
  { "code": "bg", "language": "Bulgarian" },
  { "code": "bg-BG", "language": "Bulgarian (Bulgaria)" },
  { "code": "bm", "language": "Bambara" },
  { "code": "bm-ML", "language": "Bambara (Mali)" },
  { "code": "bn", "language": "Bengali" },
  { "code": "bn-BD", "language": "Bengali (Bangladesh)" },
  { "code": "bn-IN", "language": "Bengali (India)" },
  { "code": "bo", "language": "Tibetan" },
  { "code": "bo-CN", "language": "Tibetan (China)" },
  { "code": "bo-IN", "language": "Tibetan (India)" },
  { "code": "br", "language": "Breton" },
  { "code": "br-FR", "language": "Breton (France)" },
  { "code": "bs", "language": "Bosnian" },
  { "code": "bs-BA", "language": "Bosnian (Bosnia and Herzegovina)" },
  { "code": "ca", "language": "Catalan" },
  { "code": "ca-AD", "language": "Catalan (Andorra)" },
  { "code": "ca-ES", "language": "Catalan (Spain)" },
  { "code": "ca-FR", "language": "Catalan (France)" },
  { "code": "ca-IT", "language": "Catalan (Italy)" },
  { "code": "ce", "language": "Chechen" },
  { "code": "ce-RU", "language": "Chechen (Russia)" },
  { "code": "cs", "language": "Czech" },
  { "code": "cs-CZ", "language": "Czech (Czech Republic)" },
  { "code": "cy", "language": "Welsh" },
  { "code": "cy-GB", "language": "Welsh (United Kingdom)" },
  { "code": "da", "language": "Danish" },
  { "code": "da-DK", "language": "Danish (Denmark)" },
  { "code": "de", "language": "German" },
  { "code": "de-AT", "language": "German (Austria)" },
  { "code": "de-BE", "language": "German (Belgium)" },
  { "code": "de-CH", "language": "German (Switzerland)" },
  { "code": "de-DE", "language": "German (Germany)" },
  { "code": "de-LI", "language": "German (Liechtenstein)" },
  { "code": "de-LU", "language": "German (Luxembourg)" },
  { "code": "dv", "language": "Divehi" },
  { "code": "dv-MV", "language": "Divehi (Maldives)" },
  { "code": "dz", "language": "Dzongkha" },
  { "code": "dz-BT", "language": "Dzongkha (Bhutan)" },
  { "code": "ee", "language": "Ewe" },
  { "code": "ee-GH", "language": "Ewe (Ghana)" },
  { "code": "ee-TG", "language": "Ewe (Togo)" },
  { "code": "el", "language": "Greek" },
  { "code": "el-CY", "language": "Greek (Cyprus)" },
  { "code": "el-GR", "language": "Greek (Greece)" },
  { "code": "en", "language": "English" },
  { "code": "en-AG", "language": "English (Antigua and Barbuda)" },
  { "code": "en-AI", "language": "English (Anguilla)" },
  { "code": "en-AS", "language": "English (American Samoa)" },
  { "code": "en-AU", "language": "English (Australia)" },
  { "code": "en-BB", "language": "English (Barbados)" },
  { "code": "en-BE", "language": "English (Belgium)" },
  { "code": "en-BM", "language": "English (Bermuda)" },
  { "code": "en-BS", "language": "English (Bahamas)" },
  { "code": "en-BW", "language": "English (Botswana)" },
  { "code": "en-BZ", "language": "English (Belize)" },
  { "code": "en-CA", "language": "English (Canada)" },
  { "code": "en-GB", "language": "English (United Kingdom)" },
  { "code": "en-GD", "language": "English (Grenada)" },
  { "code": "en-GG", "language": "English (Guernsey)" },
  { "code": "en-GH", "language": "English (Ghana)" },
  { "code": "en-GI", "language": "English (Gibraltar)" },
  { "code": "en-GM", "language": "English (Gambia)" },
  { "code": "en-GU", "language": "English (Guam)" },
  { "code": "en-GY", "language": "English (Guyana)" },
  { "code": "en-HK", "language": "English (Hong Kong)" },
  { "code": "en-IE", "language": "English (Ireland)" },
  { "code": "en-IM", "language": "English (Isle of Man)" },
  { "code": "en-IN", "language": "English (India)" },
  { "code": "en-JE", "language": "English (Jersey)" },
  { "code": "en-JM", "language": "English (Jamaica)" },
  { "code": "en-KE", "language": "English (Kenya)" },
  { "code": "en-KI", "language": "English (Kiribati)" },
  { "code": "en-KN", "language": "English (Saint Kitts and Nevis)" },
  { "code": "en-KY", "language": "English (Cayman Islands)" },
  { "code": "en-LC", "language": "English (Saint Lucia)" },
  { "code": "en-LR", "language": "English (Liberia)" },
  { "code": "en-LS", "language": "English (Lesotho)" },
  { "code": "en-MG", "language": "English (Madagascar)" },
  { "code": "en-MH", "language": "English (Marshall Islands)" },
  { "code": "en-MO", "language": "English (Macau)" },
  { "code": "en-MP", "language": "English (Northern Mariana Islands)" },
  { "code": "en-MS", "language": "English (Montserrat)" },
  { "code": "en-MT", "language": "English (Malta)" },
  { "code": "en-MU", "language": "English (Mauritius)" },
  { "code": "en-MW", "language": "English (Malawi)" },
  { "code": "en-MY", "language": "English (Malaysia)" },
  { "code": "en-NA", "language": "English (Namibia)" },
  { "code": "en-NF", "language": "English (Norfolk Island)" },
  { "code": "en-NG", "language": "English (Nigeria)" },
  { "code": "en-NR", "language": "English (Nauru)" },
  { "code": "en-NU", "language": "English (Niue)" },
  { "code": "en-NZ", "language": "English (New Zealand)" },
  { "code": "en-PG", "language": "English (Papua New Guinea)" },
  { "code": "en-PH", "language": "English (Philippines)" },
  { "code": "en-PK", "language": "English (Pakistan)" },
  { "code": "en-PN", "language": "English (Pitcairn Islands)" },
  { "code": "en-PR", "language": "English (Puerto Rico)" },
  { "code": "en-PW", "language": "English (Palau)" },
  { "code": "en-RW", "language": "English (Rwanda)" },
  { "code": "en-SB", "language": "English (Solomon Islands)" },
  { "code": "en-SC", "language": "English (Seychelles)" },
  { "code": "en-SD", "language": "English (Sudan)" },
  { "code": "en-SG", "language": "English (Singapore)" },
  { "code": "en-SH", "language": "English (Saint Helena)" },
  { "code": "en-SL", "language": "English (Sierra Leone)" },
  { "code": "en-SZ", "language": "English (Swaziland)" },
  { "code": "en-TC", "language": "English (Turks and Caicos Islands)" },
  { "code": "en-TO", "language": "English (Tonga)" },
  { "code": "en-TT", "language": "English (Trinidad and Tobago)" },
  { "code": "en-TV", "language": "English (Tuvalu)" },
  { "code": "en-TZ", "language": "English (Tanzania)" },
  { "code": "en-UG", "language": "English (Uganda)" },
  { "code": "en-US", "language": "English (United States)" },
  { "code": "en-VC", "language": "English (Saint Vincent and the Grenadines)" },
  { "code": "en-VG", "language": "English (British Virgin Islands)" },
  { "code": "en-VI", "language": "English (U.S. Virgin Islands)" },
  { "code": "en-VU", "language": "English (Vanuatu)" },
  { "code": "en-WS", "language": "English (Samoa)" },
  { "code": "en-ZA", "language": "English (South Africa)" },
  { "code": "en-ZM", "language": "English (Zambia)" },
  { "code": "en-ZW", "language": "English (Zimbabwe)" },
  { "code": "eo", "language": "Esperanto" },
  { "code": "es", "language": "Spanish" },
  { "code": "es-AR", "language": "Spanish (Argentina)" },
  { "code": "es-BO", "language": "Spanish (Bolivia)" },
  { "code": "es-CL", "language": "Spanish (Chile)" },
  { "code": "es-CO", "language": "Spanish (Colombia)" },
  { "code": "es-CR", "language": "Spanish (Costa Rica)" },
  { "code": "es-DO", "language": "Spanish (Dominican Republic)" },
  { "code": "es-EC", "language": "Spanish (Ecuador)" },
  { "code": "es-ES", "language": "Spanish (Spain)" },
  { "code": "es-GT", "language": "Spanish (Guatemala)" },
  { "code": "es-HN", "language": "Spanish (Honduras)" },
  { "code": "es-MX", "language": "Spanish (Mexico)" },
  { "code": "es-NI", "language": "Spanish (Nicaragua)" },
  { "code": "es-PA", "language": "Spanish (Panama)" },
  { "code": "es-PE", "language": "Spanish (Peru)" },
  { "code": "es-PR", "language": "Spanish (Puerto Rico)" },
  { "code": "es-PY", "language": "Spanish (Paraguay)" },
  { "code": "es-SV", "language": "Spanish (El Salvador)" },
  { "code": "es-US", "language": "Spanish (United States)" },
  { "code": "es-UY", "language": "Spanish (Uruguay)" },
  { "code": "es-VE", "language": "Spanish (Venezuela)" },
  { "code": "et", "language": "Estonian" },
  { "code": "et-EE", "language": "Estonian (Estonia)" },
  { "code": "eu", "language": "Basque" },
  { "code": "eu-ES", "language": "Basque (Spain)" },
  { "code": "fa", "language": "Persian" },
  { "code": "fa-IR", "language": "Persian (Iran)" },
  { "code": "ff", "language": "Fulah" },
  { "code": "ff-SN", "language": "Fulah (Senegal)" },
  { "code": "fi", "language": "Finnish" },
  { "code": "fi-FI", "language": "Finnish (Finland)" },
  { "code": "fo", "language": "Faroese" },
  { "code": "fo-FO", "language": "Faroese (Faroe Islands)" },
  { "code": "fr", "language": "French" },
  { "code": "fr-BE", "language": "French (Belgium)" },
  { "code": "fr-BF", "language": "French (Burkina Faso)" },
  { "code": "fr-BI", "language": "French (Burundi)" },
  { "code": "fr-BJ", "language": "French (Benin)" },
  { "code": "fr-BL", "language": "French (Saint Barthélemy)" },
  { "code": "fr-CA", "language": "French (Canada)" },
  { "code": "fr-CD", "language": "French (Congo - Kinshasa)" },
  { "code": "fr-CF", "language": "French (Central African Republic)" },
  { "code": "fr-CG", "language": "French (Congo - Brazzaville)" },
  { "code": "fr-CH", "language": "French (Switzerland)" },
  { "code": "fr-CI", "language": "French (Côte d’Ivoire)" },
  { "code": "fr-CM", "language": "French (Cameroon)" },
  { "code": "fr-DJ", "language": "French (Djibouti)" },
  { "code": "fr-FR", "language": "French (France)" },
  { "code": "fr-GA", "language": "French (Gabon)" },
  { "code": "fr-GF", "language": "French (French Guiana)" },
  { "code": "fr-GN", "language": "French (Guinea)" },
  { "code": "fr-GP", "language": "French (Guadeloupe)" },
  { "code": "fr-GQ", "language": "French (Equatorial Guinea)" },
  { "code": "fr-HT", "language": "French (Haiti)" },
  { "code": "fr-KM", "language": "French (Comoros)" },
  { "code": "fr-LU", "language": "French (Luxembourg)" },
  { "code": "fr-MC", "language": "French (Monaco)" },
  { "code": "fr-MF", "language": "French (Saint Martin)" },
  { "code": "fr-MG", "language": "French (Madagascar)" },
  { "code": "fr-ML", "language": "French (Mali)" },
  { "code": "fr-MQ", "language": "French (Martinique)" },
  { "code": "fr-NE", "language": "French (Niger)" },
  { "code": "fr-RE", "language": "French (Réunion)" },
  { "code": "fr-RW", "language": "French (Rwanda)" },
  { "code": "fr-SN", "language": "French (Senegal)" },
  { "code": "fr-TD", "language": "French (Chad)" },
  { "code": "fr-TG", "language": "French (Togo)" },
  { "code": "fr-YT", "language": "French (Mayotte)" },
  { "code": "fy", "language": "Western Frisian" },
  { "code": "fy-NL", "language": "Western Frisian (Netherlands)" },
  { "code": "ga", "language": "Irish" },
  { "code": "ga-IE", "language": "Irish (Ireland)" },
  { "code": "gd", "language": "Scottish Gaelic" },
  { "code": "gd-GB", "language": "Scottish Gaelic (United Kingdom)" },
  { "code": "gl", "language": "Galician" },
  { "code": "gl-ES", "language": "Galician (Spain)" },
  { "code": "gu", "language": "Gujarati" },
  { "code": "gu-IN", "language": "Gujarati (India)" },
  { "code": "gv", "language": "Manx" },
  { "code": "gv-IM", "language": "Manx (Isle of Man)" },
  { "code": "ha", "language": "Hausa" },
  { "code": "ha-GH", "language": "Hausa (Ghana)" },
  { "code": "ha-NE", "language": "Hausa (Niger)" },
  { "code": "ha-NG", "language": "Hausa (Nigeria)" },
  { "code": "he", "language": "Hebrew" },
  { "code": "he-IL", "language": "Hebrew (Israel)" },
  { "code": "hi", "language": "Hindi" },
  { "code": "hi-IN", "language": "Hindi (India)" },
  { "code": "hr", "language": "Croatian" },
  { "code": "hr-HR", "language": "Croatian (Croatia)" },
  { "code": "hu", "language": "Hungarian" },
  { "code": "hu-HU", "language": "Hungarian (Hungary)" },
  { "code": "hy", "language": "Armenian" },
  { "code": "hy-AM", "language": "Armenian (Armenia)" },
  { "code": "id", "language": "Indonesian" },
  { "code": "id-ID", "language": "Indonesian (Indonesia)" },
  { "code": "ig", "language": "Igbo" },
  { "code": "ig-NG", "language": "Igbo (Nigeria)" },
  { "code": "ii", "language": "Sichuan Yi" },
  { "code": "ii-CN", "language": "Sichuan Yi (China)" },
  { "code": "is", "language": "Icelandic" },
  { "code": "is-IS", "language": "Icelandic (Iceland)" },
  { "code": "it", "language": "Italian" },
  { "code": "it-CH", "language": "Italian (Switzerland)" },
  { "code": "it-IT", "language": "Italian (Italy)" },
  { "code": "ja", "language": "Japanese" },
  { "code": "ja-JP", "language": "Japanese (Japan)" },
  { "code": "ka", "language": "Georgian" },
  { "code": "ka-GE", "language": "Georgian (Georgia)" },
  { "code": "ki", "language": "Kikuyu" },
  { "code": "ki-KE", "language": "Kikuyu (Kenya)" },
  { "code": "kk", "language": "Kazakh" },
  { "code": "kk-KZ", "language": "Kazakh (Kazakhstan)" },
  { "code": "kl", "language": "Kalaallisut" },
  { "code": "kl-GL", "language": "Kalaallisut (Greenland)" },
  { "code": "km", "language": "Khmer" },
  { "code": "km-KH", "language": "Khmer (Cambodia)" },
  { "code": "kn", "language": "Kannada" },
  { "code": "kn-IN", "language": "Kannada (India)" },
  { "code": "ko", "language": "Korean" },
  { "code": "ko-KR", "language": "Korean (South Korea)" },
  { "code": "ks", "language": "Kashmiri" },
  { "code": "ks-IN", "language": "Kashmiri (India)" },
  { "code": "kw", "language": "Cornish" },
  { "code": "kw-GB", "language": "Cornish (United Kingdom)" },
  { "code": "ky", "language": "Kyrgyz" },
  { "code": "ky-KG", "language": "Kyrgyz (Kyrgyzstan)" },
  { "code": "lg", "language": "Ganda" },
  { "code": "lg-UG", "language": "Ganda (Uganda)" },
  { "code": "ln", "language": "Lingala" },
  { "code": "ln-CD", "language": "Lingala (Congo - Kinshasa)" },
  { "code": "ln-CG", "language": "Lingala (Congo - Brazzaville)" },
  { "code": "lo", "language": "Lao" },
  { "code": "lo-LA", "language": "Lao (Laos)" },
  { "code": "lt", "language": "Lithuanian" },
  { "code": "lt-LT", "language": "Lithuanian (Lithuania)" },
  { "code": "lu", "language": "Luba-Katanga" },
  { "code": "lu-CD", "language": "Luba-Katanga (Congo - Kinshasa)" },
  { "code": "lv", "language": "Latvian" },
  { "code": "lv-LV", "language": "Latvian (Latvia)" },
  { "code": "mg", "language": "Malagasy" },
  { "code": "mg-MG", "language": "Malagasy (Madagascar)" },
  { "code": "mk", "language": "Macedonian" },
  { "code": "mk-MK", "language": "Macedonian (Macedonia)" },
  { "code": "ml", "language": "Malayalam" },
  { "code": "ml-IN", "language": "Malayalam (India)" },
  { "code": "mn", "language": "Mongolian" },
  { "code": "mn-MN", "language": "Mongolian (Mongolia)" },
  { "code": "mr", "language": "Marathi" },
  { "code": "mr-IN", "language": "Marathi (India)" },
  { "code": "ms", "language": "Malay" },
  { "code": "ms-BN", "language": "Malay (Brunei)" },
  { "code": "ms-MY", "language": "Malay (Malaysia)" },
  { "code": "mt", "language": "Maltese" },
  { "code": "mt-MT", "language": "Maltese (Malta)" },
  { "code": "my", "language": "Burmese" },
  { "code": "my-MM", "language": "Burmese (Myanmar (Burma))" },
  { "code": "nb", "language": "Norwegian Bokmål" },
  { "code": "nb-NO", "language": "Norwegian Bokmål (Norway)" },
  { "code": "nd", "language": "North Ndebele" },
  { "code": "nd-ZW", "language": "North Ndebele (Zimbabwe)" },
  { "code": "ne", "language": "Nepali" },
  { "code": "ne-IN", "language": "Nepali (India)" },
  { "code": "ne-NP", "language": "Nepali (Nepal)" },
  { "code": "nl", "language": "Dutch" },
  { "code": "nl-AW", "language": "Dutch (Aruba)" },
  { "code": "nl-BE", "language": "Dutch (Belgium)" },
  { "code": "nl-CW", "language": "Dutch (Curaçao)" },
  { "code": "nl-NL", "language": "Dutch (Netherlands)" },
  { "code": "nl-SX", "language": "Dutch (Sint Maarten)" },
  { "code": "nn", "language": "Norwegian Nynorsk" },
  { "code": "nn-NO", "language": "Norwegian Nynorsk (Norway)" },
  { "code": "no", "language": "Norwegian" },
  { "code": "om", "language": "Oromo" },
  { "code": "om-ET", "language": "Oromo (Ethiopia)" },
  { "code": "om-KE", "language": "Oromo (Kenya)" },
  { "code": "or", "language": "Oriya" },
  { "code": "or-IN", "language": "Oriya (India)" },
  { "code": "os", "language": "Ossetic" },
  { "code": "os-GE", "language": "Ossetic (Georgia)" },
  { "code": "os-RU", "language": "Ossetic (Russia)" },
  { "code": "pa", "language": "Punjabi" },
  { "code": "pa-IN", "language": "Punjabi (India)" },
  { "code": "pa-PK", "language": "Punjabi (Pakistan)" },
  { "code": "pl", "language": "Polish" },
  { "code": "pl-PL", "language": "Polish (Poland)" },
  { "code": "ps", "language": "Pashto" },
  { "code": "ps-AF", "language": "Pashto (Afghanistan)" },
  { "code": "pt", "language": "Portuguese" },
  { "code": "pt-BR", "language": "Portuguese (Brazil)" },
  { "code": "pt-GW", "language": "Portuguese (Guinea-Bissau)" },
  { "code": "pt-MZ", "language": "Portuguese (Mozambique)" },
  { "code": "pt-PT", "language": "Portuguese (Portugal)" },
  { "code": "qu", "language": "Quechua" },
  { "code": "qu-BO", "language": "Quechua (Bolivia)" },
  { "code": "qu-EC", "language": "Quechua (Ecuador)" },
  { "code": "qu-PE", "language": "Quechua (Peru)" },
  { "code": "rm", "language": "Romansh" },
  { "code": "rm-CH", "language": "Romansh (Switzerland)" },
  { "code": "rn", "language": "Rundi" },
  { "code": "rn-BI", "language": "Rundi (Burundi)" },
  { "code": "ro", "language": "Romanian" },
  { "code": "ro-MD", "language": "Romanian (Moldova)" },
  { "code": "ro-RO", "language": "Romanian (Romania)" },
  { "code": "ru", "language": "Russian" },
  { "code": "ru-MD", "language": "Russian (Moldova)" },
  { "code": "ru-RU", "language": "Russian (Russia)" },
  { "code": "ru-UA", "language": "Russian (Ukraine)" },
  { "code": "rw", "language": "Kinyarwanda" },
  { "code": "rw-RW", "language": "Kinyarwanda (Rwanda)" },
  { "code": "sg", "language": "Sango" },
  { "code": "sg-CF", "language": "Sango (Central African Republic)" },
  { "code": "si", "language": "Sinhala" },
  { "code": "si-LK", "language": "Sinhala (Sri Lanka)" },
  { "code": "sk", "language": "Slovak" },
  { "code": "sk-SK", "language": "Slovak (Slovakia)" },
  { "code": "sl", "language": "Slovenian" },
  { "code": "sl-SI", "language": "Slovenian (Slovenia)" },
  { "code": "sn", "language": "Shona" },
  { "code": "sn-ZW", "language": "Shona (Zimbabwe)" },
  { "code": "so", "language": "Somali" },
  { "code": "so-DJ", "language": "Somali (Djibouti)" },
  { "code": "so-ET", "language": "Somali (Ethiopia)" },
  { "code": "so-KE", "language": "Somali (Kenya)" },
  { "code": "so-SO", "language": "Somali (Somalia)" },
  { "code": "sq", "language": "Albanian" },
  { "code": "sq-AL", "language": "Albanian (Albania)" },
  { "code": "sr", "language": "Serbian" },
  { "code": "sr-BA", "language": "Serbian (Bosnia and Herzegovina)" },
  { "code": "sr-ME", "language": "Serbian (Montenegro)" },
  { "code": "sr-RS", "language": "Serbian (Serbia)" },
  { "code": "sv", "language": "Swedish" },
  { "code": "sv-AX", "language": "Swedish (Åland Islands)" },
  { "code": "sv-FI", "language": "Swedish (Finland)" },
  { "code": "sv-SE", "language": "Swedish (Sweden)" },
  { "code": "sw", "language": "Swahili" },
  { "code": "sw-KE", "language": "Swahili (Kenya)" },
  { "code": "sw-TZ", "language": "Swahili (Tanzania)" },
  { "code": "ta", "language": "Tamil" },
  { "code": "ta-IN", "language": "Tamil (India)" },
  { "code": "ta-LK", "language": "Tamil (Sri Lanka)" },
  { "code": "te", "language": "Telugu" },
  { "code": "te-IN", "language": "Telugu (India)" },
  { "code": "th", "language": "Thai" },
  { "code": "th-TH", "language": "Thai (Thailand)" },
  { "code": "ti", "language": "Tigrinya" },
  { "code": "ti-ER", "language": "Tigrinya (Eritrea)" },
  { "code": "ti-ET", "language": "Tigrinya (Ethiopia)" },
  { "code": "to", "language": "Tongan" },
  { "code": "to-TO", "language": "Tongan (Tonga)" },
  { "code": "tr", "language": "Turkish" },
  { "code": "tr-TR", "language": "Turkish (Turkey)" },
  { "code": "tt", "language": "Tatar" },
  { "code": "tt-RU", "language": "Tatar (Russia)" },
  { "code": "ug", "language": "Uyghur" },
  { "code": "ug-CN", "language": "Uyghur (China)" },
  { "code": "uk", "language": "Ukrainian" },
  { "code": "uk-UA", "language": "Ukrainian (Ukraine)" },
  { "code": "ur", "language": "Urdu" },
  { "code": "ur-IN", "language": "Urdu (India)" },
  { "code": "ur-PK", "language": "Urdu (Pakistan)" },
  { "code": "uz", "language": "Uzbek" },
  { "code": "uz-AF", "language": "Uzbek (Afghanistan)" },
  { "code": "uz-UZ", "language": "Uzbek (Uzbekistan)" },
  { "code": "vi", "language": "Vietnamese" },
  { "code": "vi-VN", "language": "Vietnamese (Vietnam)" },
  { "code": "yo", "language": "Yoruba" },
  { "code": "yo-NG", "language": "Yoruba (Nigeria)" },
  { "code": "zh", "language": "Chinese" },
  { "code": "zh-CN", "language": "Chinese (China)" },
  { "code": "zh-HK", "language": "Chinese (Hong Kong)" },
  { "code": "zh-MO", "language": "Chinese (Macau)" },
  { "code": "zh-SG", "language": "Chinese (Singapore)" },
  { "code": "zh-TW", "language": "Chinese (Taiwan)" },
  { "code": "zu", "language": "Zulu" },
  { "code": "zu-ZA", "language": "Zulu (South Africa)" }
]
